import React, { useState, useEffect } from 'react';

export function StakeKeypad({ label = 'Stake', value = 50, onChange, onClose }) {
  const [input, setInput] = useState(value.toString());

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleKey = (num) => {
    if (input.length >= 7) return; // Allow for up to 7 digits (millions)
    if (input === '0') {
      setInput(num);
    } else {
      setInput(input + num);
    }
  };

  const handleBackspace = () => {
    if (input.length === 1) {
      setInput('0');
    } else {
      setInput(input.slice(0, -1));
    }
  };

  const handleSubmit = () => {
    const val = parseInt(input, 10);
    if (!isNaN(val)) {
      onChange(val);
      if (onClose) onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center h-full w-full bg-black bg-opacity-75 text-white p-4 z-[9999] backdrop-blur-sm">
      {onClose && (
        <button 
          className="absolute top-4 left-4 text-gray-400 hover:text-white p-2 rounded-full hover:bg-gray-800 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
      )}
      <div className="text-3xl font-bold mb-4" style={{ letterSpacing: 2, fontFamily: 'Mulish' }}>{label}</div>
      <div className="flex items-center justify-center mb-6">
        <span className="text-[60px] font-bold" style={{ fontFamily: 'Mulish' }}>$</span>
        <span className="text-[80px] font-bold ml-2" style={{ fontFamily: 'Mulish' }}>
          {parseInt(input).toLocaleString()}
        </span>
      </div>
      <div className="w-full max-w-xs">
        <div className="grid grid-cols-3 gap-4 mb-4">
          {[1,2,3,4,5,6,7,8,9].map(n => (
            <button
              key={n}
              className="bg-gray-800 text-white text-2xl rounded-lg py-4 hover:bg-blue-700 transition-colors"
              onClick={() => handleKey(n.toString())}
            >
              {n}
            </button>
          ))}
          <div></div>
          <button
            className="bg-gray-800 text-white text-2xl rounded-lg py-4 hover:bg-blue-700 transition-colors"
            onClick={() => handleKey('0')}
          >
            0
          </button>
          <button
            className="bg-gray-800 text-white text-2xl rounded-lg py-4 hover:bg-blue-700 transition-colors"
            onClick={handleBackspace}
          >
            ←
          </button>
          <button
            className="bg-blue-600 text-white text-2xl rounded-lg py-4 hover:bg-blue-700 transition-colors col-span-3"
            onClick={handleSubmit}
          >
            OK
          </button>
        </div>
      </div>
      {onClose && (
        <button className="mt-4 text-gray-400 hover:text-white px-6 py-2 rounded-lg" onClick={onClose}>Cancel</button>
      )}
    </div>
  );
}
